import { createSelector, Selector } from '@ngrx/store';
import { Seq } from 'immutable';
import { AppState } from '../appstate';
import { UnitPositionRecord } from '../generated/unit-position-record.generated';
import { selectAllUnitPostions } from './entity-store-selectors';

export function selectUnitPositionById(unitPositionId: string) {
  return createSelector(selectAllUnitPostions, (trips) => {
    return trips.valueSeq().find((p) => p.id === unitPositionId);
  });
}

export function selectUnitPositionsByUnitId(
  unitId: string,
): Selector<AppState, Seq.Indexed<UnitPositionRecord>> {
  return createSelector(selectAllUnitPostions, (positions) =>
    positions.valueSeq().filter((p) => p.unitId === unitId),
  );
}

export function selectUnitPositionsMapByUnitId(unitId: string) {
  return createSelector(selectAllUnitPostions, (positions) =>
    positions.filter((p) => p.unitId === unitId),
  );
}
